<template>
  <!--
    WHAT: A multi-column sortable table header cell (<th>). Shows the column
          label (default slot), a direction arrow (▲/▼) when this column is an
          active sort, a numbered rank badge when more than one sort is active,
          and a neutral ↕ affordance otherwise.
    WHERE: [reused v1] Used by the studio's list/table headers (e.g. ArtifactList
           and other tables). Not tied to one section.
    CONTRACT:
      props:
        sortKey (String, req)  — this column's sort key
        sorts (Array, req)     — current sort state: [{ key, dir:'asc'|'desc' }]
        rowspan (Number|String) — optional cell rowspan
        sub (Boolean)          — smaller "sub-header" styling
      emits: sort(sortKey)  — parent owns the sort state + toggle logic
    NOTES: [reused v1] shared component — do NOT restyle without checking other
           callers. Gotcha: this cell is presentational only; it emits `sort` and
           reads `sorts` but never mutates it (rank = 1-based index within sorts).
  -->
  <th
    :rowspan="rowspan || undefined"
    class="px-2 text-left uppercase tracking-wider cursor-pointer select-none align-bottom hover:bg-gray-100"
    :class="[
      sub ? 'pb-1.5 text-[10px] font-medium text-gray-500' : 'py-1.5 text-xs font-semibold text-gray-600',
      active ? 'text-gray-900' : '',
    ]"
    @click="$emit('sort', sortKey)"
  >
    <span class="inline-flex items-center gap-1">
      <slot />
      <span v-if="active" class="inline-flex items-center gap-0.5 text-[9px] text-gray-700">
        <span>{{ entry.dir === 'asc' ? '▲' : '▼' }}</span>
        <span
          v-if="sorts.length > 1"
          class="inline-flex items-center justify-center w-3 h-3 rounded-full bg-gray-700 text-white text-[8px] leading-none font-semibold"
        >{{ rank }}</span>
      </span>
      <span v-else class="text-[9px] text-gray-300">↕</span>
    </span>
  </th>
</template>

<script>
export default {
  name: 'SortableTh',
  props: {
    sortKey: { type: String, required: true },
    sorts: { type: Array, required: true },
    rowspan: { type: [Number, String], default: null },
    sub: { type: Boolean, default: false },
  },
  emits: ['sort'],
  computed: {
    rank() {
      return this.sorts.findIndex((s) => s.key === this.sortKey) + 1;
    },
    entry() {
      return this.sorts.find((s) => s.key === this.sortKey) || null;
    },
    active() {
      return this.entry !== null;
    },
  },
};
</script>
